var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"piearticuloschart-comp"},[_c('div',{staticClass:"pie-chart-container"},[_c('canvas',{staticClass:"pie-chart",attrs:{"id":"pie-chart","width":"70%","height":"100%"}})])])
}]

export { render, staticRenderFns }